<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生产加工单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="5">
              <el-form-item label="订单" prop="orderNo">
                <el-input v-model="searchform.orderNo" type="text" clearable placeholder="请输入订单" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="产品编码" prop="product_code">
                <el-select style="width:100%" v-model="searchform.product_code" clearable filterable remote
                  placeholder="请输入产品名称或编码模糊匹配" :remote-method="getProductSelectList" :loading="productSelectLoading">
                  <el-option v-for="item in productSelectList" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="erpId" prop="erp_id">
                <el-input v-model="searchform.erp_id" type="text" clearable placeholder="请输入erpId" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="计划生产日期" prop="plan_date" label-width="120px">
                <el-date-picker style="width: 100%" v-model="searchform.plan_date" type="date" value-format="yyyy-MM-dd"
                  format="yyyy 年 MM 月 dd 日" clearable placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button v-permission="['orderPlus_select']" type="primary" icon="el-icon-search" @click="search()">搜索
              </el-button>
              <el-button v-permission="['orderPlus_add']" type="primary" @click="addOrder()">新增工单</el-button>
              <el-button v-permission="['orderSubtask_select']" type="primary" @click="settatle()">设置表列显示</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <OrderAdd ref="orderAdd" :search="search" />
      <orderResolve ref="orderResolve" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title }}</h4>
          <el-divider></el-divider>
          <el-table border v-loading="tableLoading" element-loading-text="拼命加载中" :data="tableData" style="width: 100%"
            id="parent">
            <el-table-column type="expand">
              <h3>原料列表</h3>
              <template slot-scope="props">
                <el-table :data="props.row.material_json" style="width: 100%">
                  <el-table-column prop="material_code" label="原料编码" width="120">
                  </el-table-column>
                  <el-table-column prop="material_name" label="原料名称" width="250">
                  </el-table-column>
                  <el-table-column prop="material_quantity" label="原料计划数量" width="250">
                  </el-table-column>
                  <el-table-column prop="resolve_quantity" label="原料分解数量" width="120">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column v-for="item in tablerow" :key="item.key" :prop="item.key" :label="item.label"
              :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
            </el-table-column>
            <el-table-column min-width="220" label="操作" fixed="right">
              <template slot-scope="props">
                <el-button v-permission="['orderPlus_update']" type="danger" @click="deletedate(props.row.id, 1)">
                  结束 </el-button>
                <el-button v-permission="['orderPlus_update']" type="primary" @click="handleResolve(props.row)">
                  分解 </el-button>
                <el-button v-permission="['orderPlus_delete']" type="danger"
                  @click="deletedate(props.row.id, 2)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="pageTotal"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchform.page_size"
            :current-page.sync="searchform.page_index" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>
      <TableHeader ref="TableHeader" :tablecolumn="tablecolumn" />
    </div>
  </div>
</template>
<script>
import { workorderprocessingList, workorderprocessingDelete, workorderprocessingComplete } from "@/api/plant";
import { productlist } from "@/api/base";
import OrderAdd from "./components/orderPlus/OrderAdd";
import orderResolve from "./components/orderPlus/orderResolve";
import TableHeader from "@/components/HeaderSearch/TableHeader";
export default {
  name: "orderPlus",
  components: { OrderAdd, orderResolve, TableHeader },
  data() {
    return {
      //表格数据
      tableLoading: false,
      tableData: [],
      tablerow: [],
      tablecolumn: [
        {
          label: "生产订单号",
          key: "orderno",
          width: "150",
        },
        {
          label: "产品编码",
          key: "product_code",
          width: "130",
        },
        {
          label: "产品名称",
          key: "product_name",
          width: "170",
        },
        {
          label: "计划生产日期",
          key: "plan_date",
          width: "100",
        },
        {
          label: "计划生产数量",
          key: "product_quantity",
          width: "100",
        },
        {
          label: "分解数量",
          key: "resolve_quantity",
          width: "80",
        },
        {
          label: "创建人",
          key: "maker",
          width: "100",
        },
        {
          label: "审核人",
          key: "auditor",
          width: "100",
        },
        {
          label: "备注",
          key: "remark",
          width: "100",
        },
        {
          label: "1级采集数量",
          key: "package_level1_count",
          width: "90",
        },
        {
          label: "1级生产数量",
          key: "package_level1_produce",
          width: "90",
        },
        {
          label: "1级采集率",
          key: "harvest_rate1",
          width: "90",
        },
        {
          label: "2级采集数量",
          key: "package_level2_count",
          width: "90",
        },
        {
          label: "2级生产数量",
          key: "package_level2_produce",
          width: "90",
        },
        {
          label: "2级采集率",
          key: "harvest_rate2",
          width: "90",
        },
        {
          label: "3级采集数量",
          key: "package_level3_count",
          width: "90",
        },
        {
          label: "3级生产数量",
          key: "package_level3_produce",
          width: "90",
        },
        {
          label: "3级采集率",
          key: "harvest_rate3",
          width: "90",
        },
        {
          label: "计划开始时间",
          key: "produce_time",
          width: "140",
        },
        {
          label: "计划结束时间",
          key: "complete_time",
          width: "140",
        },
        {
          label: "生产状态",
          key: "statusname",
          width: "80",
        },
        {
          label: "erp_id",
          key: "erp_id",
          width: "80",
        },
        {
          label: "erp状态",
          key: "erp_status",
          width: "80",
        },
      ],
      //产品下拉选择列表
      productSelectLoading: false,
      productSelectList: [],
      //分页数据
      pageTotal: 0,
      //搜索表单数据
      searchform: {
        orderNo: null,
        product_code: null,
        erp_id: null,
        plan_date: null,
        page_size: 10,
        page_index: 1,
      },
      orderstatus: [
        {
          value: 0,
          label: "未分解",
        },
        {
          value: 1,
          label: "未分解",
        },
        {
          value: 2,
          label: "已分解",
        },
        {
          value: 3,
          label: "生产中",
        },
        {
          value: 4,
          label: "生产完成",
        },
      ],
      erpStatusList: ['未推送', '推送失败', '推送成功'],
    };
  },
  mounted() {
    this.getProductSelectList();
    this.search();
  },
  methods: {
    settatle() {
      // 设置表头
      this.$refs.TableHeader.drawer = true;
    },
    getrowshow() {
      this.tablerow = this.$refs.TableHeader.tablerow;
      this.$refs.TableHeader.drawer = false;
    },
    // 获取产品下拉列表
    getProductSelectList(value) {
      if (value !== "") {
        this.productSelectLoading = true;
        setTimeout(() => {
          this.productSelectLoading = false;
          productlist({ productName: value }).then(response => {
            this.productSelectList = response.data.data || [];
            for (var item of this.productSelectList) {
              item.product = item.product_code + " - " + item.product_name;
            }
          });
        }, 200);
      } else {
        this.productSelectList = [];
      }
    },
    //请求表格数据
    fetchTableData() {
      // 列表获取
      this.tableLoading = true;
      workorderprocessingList(this.searchform).then((response) => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.pageTotal = response.data.total_count;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    packdate(data) {
      data.forEach(item => {
        item.material_json = JSON.parse(item.material_json);
        item.harvest_rate1 = item.package_level1_produce == 0 ? '0%' : (item.package_level1_count / item.package_level1_produce * 100).toFixed(2) + "%";
        item.harvest_rate2 = item.package_level2_produce == 0 ? '0%' : (item.package_level2_count / item.package_level2_produce * 100).toFixed(2) + "%";
        item.harvest_rate3 = item.package_level3_produce == 0 ? '0%' : (item.package_level3_count / item.package_level3_produce * 100).toFixed(2) + "%";
        item.plan_date = item.plan_date ? this.$parseTime(item.plan_date).slice(0, 10) : '';
        item.produce_time = item.produce_time ? this.$parseTime(item.produce_time) : '';
        item.complete_time = item.complete_time ? this.$parseTime(item.complete_time) : '';
        item.erp_status = this.erpStatusList[item.erp_status];
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tableData = [];
      this.pageTotal = 0;
      this.searchform.page_index = 1;
      this.searchform.page_size = 10;
      this.getProductSelectList();
      this.search();
    },
    //搜索事件
    search() {
      this.searchform.page_index = 1;
      this.fetchTableData();
    },
    //分页跳转事件
    handleCurrentChange(val) {
      this.fetchTableData();
    },
    //分页每页显示条数事件
    handleSizeChange(val) {
      this.fetchTableData();
    },
    // 新增工单
    addOrder() {
      this.$refs.orderResolve.resolveShow = false
      this.$refs.orderAdd.show = !this.$refs.orderAdd.show
    },
    // 分解
    handleResolve(data) {
      this.$refs.orderAdd.show = false
      //拿到列表数据
      this.$refs.orderResolve.form = data
      this.$refs.orderResolve.resolveShow = true
    },
    // 删除按钮事件
    deletedate(id, type) {
      this.$confirm(`此操作将${type == 1 ? '结束' : '删除'}该工单, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type == 1) {
            workorderprocessingComplete({ id }).then((response) => {
              this.$message({
                type: "success",
                message: "结束成功!",
              });
              this.search();
            });
          } else {
            workorderprocessingDelete({ id }).then((response) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.search();
            });
          }

        })
    },
  },
};
</script>